import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {ProjectService} from "../../../_services";
import {IndexConfigService} from "../../../_services/index.config.service";
import {Project} from "../../../_models";

@Component({
    standalone: false,
  selector: "license",
  templateUrl: 'license.component.html',
  styleUrls: ['./license.component.scss'],
})

export class LicenseComponent implements OnInit {
  projects: Project[];

  constructor(
    public router: Router,
    public projectService: ProjectService,
    public config: IndexConfigService
  ) {
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.projectService.getAllShortAdmin().subscribe(p => this.projects = p);
  }

  delete(id) {
    this.projectService.delete(id, true).subscribe(() => this.loadData());
  }
}
